<router-outlet></router-outlet>
<ms-banner [position]="'LobbyMiddleBanner'" [pageName]="'Horses'"> </ms-banner>
